var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignedMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21818 14.9999C7.98818 14.9999 7.76818 14.9049 7.61068 14.7374L3.55818 10.4216C3.24235 10.0866 3.25985 9.55906 3.59485 9.24406C3.93068 8.92906 4.45818 8.94572 4.77235 9.28072L8.20985 12.9399L15.2165 5.27156C15.5282 4.93072 16.0548 4.90822 16.3948 5.21822C16.734 5.52822 16.7573 6.05572 16.4473 6.39489L8.83318 14.7282C8.67735 14.8999 8.45568 14.9982 8.22402 14.9999H8.21818Z",
    fill: "#00A380"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5985_3874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 14,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21818 14.9999C7.98818 14.9999 7.76818 14.9049 7.61068 14.7374L3.55818 10.4216C3.24235 10.0866 3.25985 9.55906 3.59485 9.24406C3.93068 8.92906 4.45818 8.94572 4.77235 9.28072L8.20985 12.9399L15.2165 5.27156C15.5282 4.93072 16.0548 4.90822 16.3948 5.21822C16.734 5.52822 16.7573 6.05572 16.4473 6.39489L8.83318 14.7282C8.67735 14.8999 8.45568 14.9982 8.22402 14.9999H8.21818Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5985_3874)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#00A380"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedMessageIcon);
export default __webpack_public_path__ + "static/media/signed_message_icon.3a0cd70702f167d77d50d742fea36448.svg";
export { ForwardRef as ReactComponent };